import { useState } from 'react';
import { PatternFormat } from 'react-number-format';
import { Form, Input, InputFlex, Label, Thanks } from './FormComponents';
import { PrimaryBtn } from './buttons';

export const ContactForm = () => {
    const [submit, setSubmit] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSubmit(true);

        const data = Object.fromEntries(new FormData(e.currentTarget));

        await fetch(`https://api.${window.location.host}/contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    };

    return (
        <Form onSubmit={handleSubmit} submit={submit} gray>
            <InputFlex>
                <Label htmlFor="firstName">
                    <span>First Name</span>
                    <Input
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder="Enter owner’s first name"
                    />
                </Label>

                <Label htmlFor="lastName">
                    <span>Last Name</span>
                    <Input
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder="Enter owner’s last name"
                    />
                </Label>
            </InputFlex>

            <InputFlex>
                <Label htmlFor="email">
                    <span>
                        Email address<strong>*</strong>
                    </span>
                    <Input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="Enter your email address"
                    />
                </Label>
                <Label htmlFor="phone">
                    <span>Phone *</span>
                    <PatternFormat
                        type="tel"
                        format="+1 (###) ###-####"
                        customInput={Input}
                        placeholder="123 456-7890"
                        id="phone"
                        name="phone"
                        required
                    />
                </Label>
            </InputFlex>

            <Label htmlFor="message">
                <span>Your message</span>
                <Input
                    as="textarea"
                    id="message"
                    name="message"
                    rows={5}
                    placeholder="Write to us..."
                />
            </Label>
            <PrimaryBtn big>Send Message</PrimaryBtn>
            <Thanks submit={submit} setSubmit={setSubmit} />
        </Form>
    );
};
